import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  border: 1px solid var(--scheme-alpha-10);
  background-color: var(--scheme-surface-level-1);
  width: 100%;

  &:hover {
    border-color: var(--scheme-alpha-20);
    box-shadow: var(--scheme-shadow-large);
  }
`;

const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 3 / 2;
  overflow: hidden;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    scale: 1;
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 20px 24px 20px 0;
  flex-shrink: 0;
`;

const TitleWrapper = styled.div`
  width: 100%;
  min-width: 0;

  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.2;
`;

const TitleText = styled.p`
  font-weight: 400;
  font-size: 16px;
  color: var(--way-colors-primaryTextColor);
  letter-spacing: 0.02px;
  font-family: inherit;
  margin: 0 !important;
`;

const DescriptionText = styled.p`
  font-weight: 400;
  letter-spacing: 0.01px;
  font-size: 14px;
  color: var(--Text-Tertiary, rgba(0, 0, 0, 0.6));
  font-family: inherit;
  margin: 0 !important;
`;

interface GenericListingCardProps {
  title: string;
  description?: string;
  image: string;
}

const GenericListingCard = ({
  title,
  description,
  image,
}: GenericListingCardProps) => {
  return (
    <Wrapper>
      <ImageWrapper>
        <img src={image} alt={title} />
      </ImageWrapper>
      <TextWrapper>
        <TitleWrapper>
          <TitleText>{title}</TitleText>
        </TitleWrapper>
        {description && <DescriptionText>{description}</DescriptionText>}
      </TextWrapper>
    </Wrapper>
  );
};

export default GenericListingCard;
